import { useEffect, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isModalUrl } from 'utils/ModalRoute';
import { getLocationFragment, scrollToAnchor, scrollToTop } from 'utils/ScrollUtils';
import { useAllImagesLoaded } from './useAllImagesLoaded';

export function useScrollOnRender(hasPageLoaded = true) {
  const { action, location } = useHistory();
  const allImagesLoaded = useAllImagesLoaded(hasPageLoaded);
  const [previousLocation, setPreviousLocation] = useState<{ pathname: string; hash: string } | undefined>();

  useEffect(() => {
    setPreviousLocation(location);
  }, [location]);

  useLayoutEffect(() => {
    if (!allImagesLoaded || location === previousLocation) return;

    const hash = getLocationFragment(location.hash);

    const shouldScrollToAnchor = !!hash;
    const shouldScrollToTop = !isModalUrl(location.pathname) && !isModalUrl(previousLocation?.pathname ?? '');

    if (shouldScrollToAnchor) {
      const element = document.getElementById(hash);
      scrollToAnchor(element);
      return;
    }

    if (shouldScrollToTop && action === 'PUSH') {
      scrollToTop();
    }
  }, [location, action, previousLocation, allImagesLoaded]);
}
